export const TOAST_ACTIONS = {
  ADD: 'TOAST/ADD',
  REMOVE: 'TOAST/REMOVE',
};
